import axios from 'axios';
import { getErrorMessage } from '../utils/RequestUtils';
import { getToken, isAuthenticated } from './Auth/AuthService';

const api = axios.create();
const SHOW_ERROR_ON_CONSOLE = 'SHOW_ERROR_ON_CONSOLE';

export const API_STATUS_REQ_CREATE = 'Criacao';
export const API_STATUS_REQ_UPDATE = 'Edicao';

export const API_STATUS_REQ_CREATE_NUMBER = 1;
export const API_STATUS_REQ_UPDATE_NUMBER = 2;

export const errorOnConsoleIsActivate = () => {
  return typeof window.localStorage.getItem(SHOW_ERROR_ON_CONSOLE) === 'string'
    ? true
    : false;
};

api.interceptors.request.use(async (config) => {
  const authenticated = await isAuthenticated();
  const token = await getToken();
  if (authenticated && token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    };
  }
  return config;
});


api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      return Promise.reject({
        response: {
          statusText: null,
        },
      });
    }

    const status = error.response.status;

    if (status === 403 || status === 401) {
      history.push('/unauthorized');
      return;
    }
    if (
      typeof error === 'object' &&
      typeof error.response === 'object' &&
      typeof error.response.status === 'number' &&
      typeof error.response.data === 'object' &&
      error.response.status !== 200
    ) {
      error.response.statusText = getErrorMessage(error.response.data);
    }

    if (
      typeof error.response.statusText === 'string' &&
      error.response.statusText.trim().length === 0
    ) {
      error.response.statusText = null;
    }

    return Promise.reject(error);
  }
);


export default api;